<div class="dialog" [class.blocked]="cannotEdit">
    <!-- Blocking overlay when user lost edit/add permissions -->
    <div *ngIf="cannotEdit" class="blocking-overlay">
        <div class="blocking-message">
            <icc-icon name="warning" class="warning-icon"></icc-icon>
            <ng-container *ngIf="data.editMode">
                <p *ngIf="blockReason === 'appointment'">{{ 'COMPLAINT_APPOINTMENT|Status wizyty został zmieniony przez innego użytkownika. Nie możesz już edytować tej wizyty.' | translate }}</p>
                <p *ngIf="blockReason === 'complaint'">{{ 'COMPLAINT_APPOINTMENT|Reklamacja została zmodyfikowana przez innego użytkownika. Nie masz już uprawnień do edycji tej wizyty.' | translate }}</p>
            </ng-container>
            <p *ngIf="!data.editMode">{{ 'COMPLAINT_APPOINTMENT|Reklamacja została zmodyfikowana przez innego użytkownika. Nie możesz już dodać nowej wizyty.' | translate }}</p>
            <div class="blocking-actions">
                <button iccButton appearance="primary" (click)="close()">
                    {{ 'INTERFACE|Zamknij' | translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="dialog-header">
        <h3>{{ data.editMode ? ('COMPLAINT_APPOINTMENT|Edycja wizyty' | translate) : ('COMPLAINT_APPOINTMENT|Planowanie wizyty' | translate) }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>
    <div class="dialog-body">

            <icc-complaint-appointment-edit
                [(complaint)]="data.complaint"
                [(complaintAppointment)]="data.appointment"
                [(complaintAppointmentAttachments)]="data.attachments"
                [(editMode)]="data.editMode"
                (validDate)="validateDate($event)"
                (validTime)="validateTime($event)"
            ></icc-complaint-appointment-edit>

    </div>

    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <button
                iccButton
                (click)="close()"
                appearance="secondary"
            >
                {{ 'INTERFACE|Zamknij' | translate}}
            </button>
            <button
                [disabled]="!data.appointment.date || isValidDate || isValidTime"
                iccButton
                (click)="save()"
                appearance="primary"
            >
                {{ 'INTERFACE|Zapisz' | translate}}
            </button>

        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>
